// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_sxn","cls2":"RelatedWorksCard-cls2_0ah RelatedWorksCard-cls1_sxn"};